import "animate.css";
import Drip from "../apis/Drip";
import { mapState, mapGetters, mapActions } from "vuex";
import DateRangePicker from "vue2-daterange-picker";
import Customization from "../apis/Customization";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
const moment = require("moment-timezone");

const recurring = {
    components: {
        DateRangePicker,
    },
    data() {
        return {
            shwExternalSettings: false,
            selectedExternal: "",
            externalAdverts: ["evadav"],

            audId: "",
            success: false,
            failure: false,
            scheduleDatesCompatibility: true,
            fireError: false,
            processLoading: false,
            errorSnackbar: false,
            //error: "",
            selectedDomains: [],
            selectedDomainForGettingAudience: "",
            expiry: "",
            selectedNotifType: "recurring",
            selectedAudience: "",
            registration: null,
            search: "",
            snackbar: false,
            shwUtm: false,
            shwMultipleTimes: false,
            shwRecurring: false,
            shwOneTime: true,
            shwActionBtns: false,
            showStartPicker: false,
            showEndPicker: false,
            shwLargeImg: false,
            shwAudience: false,
            shwSegment: false,
            shwTimeZone: false,
            shwSchedNotif: false,
            shwBtn1: false,
            shwBtn2: false,
            shwIcons: "none",
            audienceList: [],
            minutes: "",
            seconds: "",
            spamFrequencyVariants: [
                {
                    text: "incessant",
                    value: "incessant"
                },
                {
                    text: "secondly",
                    value: "secondly"
                },
                {
                    text: "minutely",
                    value: "minutely"
                },
                {
                    text: "hourly",
                    value: "hourly"
                },
                {
                    text: "yearly",
                    value: "yearly"
                },
                {
                    text: "monthly",
                    value: "monthly"
                },
                {
                    text: "weekly",
                    value: "weekly"
                },
                {
                    text: "daily",
                    value: "daily"
                }
            ],
            frequencyVariants: [
                {
                    text: "Minutely",
                    value: "minutely"
                },
                {
                    text: "Hourly",
                    value: "hourly"
                },
                {
                    text: "Daily",
                    value: "daily"
                },
                {
                    text: "Weekly",
                    value: "weekly"
                },
                {
                    text: "Monthly",
                    value: "monthly"
                },
                {
                    text: "Yearly",
                    value: "yearly"
                },
            ],
            daysOfTheWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday"
            ],
            // For Date & Time Picker
            endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            time: null,
            menu: false,
            modal: false,
            modalTime: false,
            modalStart: false,
            modalEnd: false,
            menu2: false,
            // For Push Object
            icon: null,
            lgImg: null,
            title: "",
            button1: {
                title: "",
                url: "",
            },
            button2: {
                title: "",
                url: "",
            },
            ttl: "",
            message: "",
            url: "",
            modal2: false,
            freq: "daily",
            emptyRecurringDrip:
                [{
                    "domain_id": null,
                    "type": "recurring",
                    "title": "",
                    "body": "",
                    "url": "",
                    "icon": "",
                    "customization": {
                        "requireInteraction": false,
                        "ttl": "",
                        "image": "",
                        "button1": {
                            "title": "",
                            "url": null
                        },
                        "button2": {
                            "title": "",
                            "url": null
                        }
                    },
                    "meta": null,
                    "is_active": 1,
                    "audiences": [],
                    "schedules": [
                        {
                            "domain_id": null,
                            "type": "",
                            "frequency": null,
                            "time": null,
                            "date_start": null,
                            "date_end": null,
                            "timezone": "",
                            "days_of_week": "Monday Tuesday Wednesday Thursday Friday Saturday Sunday",
                            "is_active": 1,
                        }
                    ]
                }],
            // For Data Table
            headers: [
                { text: "Timezone", value: "" },
                { text: "Current Time", value: "" },
                { text: "Schedule Time", value: "" },
            ],
            items: [],
            timezones: moment.tz.names(),
            openTreeview: [],
            opened: [],
            tags: [],
            selectedTagsForSorting: [],
            selectedTags: [],
            isFormValid: false,
            rules: {
                required: value => !!value || 'Required.',
                titleCounter: value => !!value && value.length <= 30 || 'Max 30 characters',
                bodyCounter: value => !!value && value.length <= 50 || 'Max 50 characters',
                minRule: v => (v >= 15 && v < 60) || '15-60 only.',
                secRule: v => (v >= 0 && v < 60) || '0–59 only.',
            },
        };
    },
    computed: {
        ...mapState({
            filters: (state) => state.audience.filters,
            //audience: (state) => state.audience.audienceRecords,
            segments: (state) => state.segment.segments,
            //error: (state) => state.recurringDrip.errorRecurringDrip,
            domains: (state) => state.domain.domains,
            pushStructure: (state) => state.push.pushStructure,
            one: (state) => state.push.one,
            multiple: (state) => state.push.multiple,
            recurring: (state) => state.push.recurring,
            //recurringDrips: (state) => state.recurringDrip.recurringDrips,
            emptypushStructure: (state) => state.push.emptypushStructure,
        }),
        isRecurringTail() {
            return this.recurringDrips !== undefined && this.checkField(this.recurringDrips.schedules) !== undefined && this.checkField(this.recurringDrips.schedules)["type"] === "tail-recurring";
        },
        error: {
            get: function () {
                return this.$store.state.recurringDrip.errorRecurringDrip;
            },
            set: function (newValue) {
                return newValue;
            }
        },
        audience: {
            get: function () {
                return this.$store.state.audience.audienceRecords;
            },
            set: function (newValue) {
                return newValue;
            }
        },
        recurringDrips: {
            get: function () {
                return this.$store.state.recurringDrip.recurringDrips;
            },
            set: function (newValue) {
                return newValue;
            }
        },
        filteredDomains() {
            return this.domains.filter((p) => {
                return (
                    p.url.toLowerCase().indexOf(this.search.toLowerCase()) != -1 ||
                    (p.domain_tags.length &&
                        p.domain_tags.some((el) => el.name === this.search))
                );
            });
        },
        ...mapGetters(["selectedDomain"]),
    },
    mounted() {
        if (this.$route.name === "Send" || this.$route.name === "Drip Setup") {
            this.$store.state.recurringDrip.recurringDrips = this.emptyRecurringDrip[0];
        }
    },
    methods: {
        ...mapActions([
            "resetRecurringDrips",
            "show",
            "getRecurringDrips",
            "getAllFilters",
            "getSegments",
            "getSchedule",
            "addMultipleSchedule",
            "removeMultipleSchedule",
            "createOrUpdateDrip",
            "createOrUpdate",
        ]),
        checkScheduleDatesCompatibility(date_start, date_end) {
            const convertedDateStart = new Date(date_start).getTime();
            const convertedDateEnd = new Date(date_end).getTime();

            return date_start || date_end ? convertedDateStart <= convertedDateEnd : null;
        },
        handleUpdateToSnackbar(val) {
            this.snackbar = val;
        },
        checkSelectedAudience() {
            return (this.$route.name === "Send" ? this.selectedNotifType === "tail-recurring" : this.isRecurringTail) || this.recurringDrips.audiences.length;
        },
        updateTime() {
            const hh = '00'
            const mm = String(this.minutes).padStart(2, '0')
            const ss = String(this.seconds).padStart(2, '0')
            this.recurring[0].schedule.time = `${hh}:${mm}:${ss}`
        },
        async create(event) {
            this.processLoading = true;

            let formData = new FormData();
            let formData1 = new FormData();
            let icon = document.querySelector("#icon");
            let image = document.querySelector("#lgImg");
            let type = this.$route.name === "Drip Setup" ? "instant" : "";
            const isTimeValid = this.recurring[0].schedule.frequency ? this.$refs.timeForm.validate() : true;

            this.recurringDrips.is_active =
                event.target.innerText == "Save" || !event.target.innerText ? 1 : 0;

            this.recurringDrips.schedules !== undefined
                ? (this.recurringDrips.schedules[0].is_active =
                    event.target.innerText == "Save" || event.target.innerText == " Recurring Notification" ? 1 : 0)
                : (this.recurringDrips.schedule.is_active =
                    event.target.innerText == "Save" || event.target.innerText == " Recurring Notification" ? 1 : 0);

            if (this.button1.title && this.shwActionBtns) {
                Object.assign(this.recurringDrips.customization, {
                    button1: this.button1,
                });
            }

            if (this.button2.title && this.shwActionBtns) {
                Object.assign(this.recurringDrips.customization, {
                    button2: this.button2,
                });
            }

            if (!this.shwActionBtns || !this.button1.title) {
                this.recurringDrips.customization?.button1 !== undefined
                    ? delete this.recurringDrips.customization.button1
                    : null;
            }

            if (!this.shwBtn2 || !this.button2.title) {
                this.recurringDrips.customization?.button2 !== undefined
                    ? delete this.recurringDrips.customization?.button2
                    : null;
            }

            if ((image && image.files[0] || this.recurringDrips.customization?.image) && !document.querySelector("#lgImage").checked) {
                delete this.recurringDrips.customization.image;
            }

            if (this.ttl) {
                Object.assign(this.recurringDrips.customization, { ttl: this.ttl });
            }

            switch (this.selectedNotifType) {
                case "one":
                    this.recurringDrips.schedule = this.one[0].schedule;
                    this.recurringDrips.schedules[0].frequency !== undefined ? delete this.recurringDrips.schedules[0].frequency : null;

                    break;
                case "multiple":
                    Object.assign(
                        this.recurringDrips.schedules[0],
                        this.multiple[0].schedule
                    );

                    break;
                case "tail-recurring":
                case "external-recurring":
                case "recurring":
                    if (typeof this.recurringDrips.schedules[0].choose_time !== undefined) {
                        delete this.recurringDrips.schedules[0].choose_time;
                    }

                    this.recurringDrips.schedule = this.recurring[0].schedule;
                    this.recurringDrips.schedule.is_active = this.checkField(this.recurringDrips.schedules)["is_active"];

                    break;
            }

            if (icon.files.length) {
                formData.append("image", icon.files[0]);
                formData.append("type", "icon");

                await Customization.uploadImg(formData)
                    .then((response) => {
                        this.recurringDrips.icon = response.data.data[0].full_url;
                    })
                    .catch((err) => {
                        this.error = err;
                    });
            }

            if (image && document.querySelector("#lgImage").checked) {
                formData1.append("image", image.files[0]);
                formData1.append("type", "image");

                await Customization.uploadImg(formData1)
                    .then((response) => {
                        Object.assign(this.recurringDrips.customization, {
                            image: response.data.data[0].full_url,
                        });
                    })
                    .catch((err) => {
                        this.error = err;
                    });
            }

            if (isTimeValid && this.recurringDrips.title && this.recurring[0].schedule.frequency && this.recurring[0].schedule.date_start && this.recurring[0].schedule.date_end && this.recurring[0].schedule.timezone && this.recurring[0].schedule.time) {
                this.selectedDomains = [...new Set(this.selectedDomains)];

                for (let [i, domain] of this.selectedDomains.entries()) {
                    this.recurringDrips.domain_id = domain;
                    this.recurringDrips.schedule.domain_id = domain;

                    if (this.$route.name === "Drip Setup" || this.$route.name === "Send") {
                        this.recurringDrips.id !== undefined ? delete this.recurringDrips.id : null;
                        this.recurringDrips.group_id !== undefined ? delete this.recurringDrips.group_id : null;
                    } else {
                        this.recurringDrips.id = this.recurringDrips.id;
                        this.recurringDrips.schedule.id = this.recurringDrips.schedule.id;
                    }

                    delete this.recurringDrips.created_at;
                    delete this.recurringDrips.updated_at;

                    this.recurringDrips.meta === null ? this.recurringDrips.meta = {} : null;
                    this.recurringDrips.meta.type = type;

                    this.recurringDrips.audiences = this.selectedAudience;
                    // this.recurringDrips.audiences = [
                    //     {
                    //         // id: this.selectedAudience.id,
                    //         domain_id: domain,
                    //         type: "audience",
                    //         name: this.selectedAudience.name,
                    //         query: this.selectedAudience.query,
                    //     },
                    // ];

                    let recurringDrips = new Array(this.recurringDrips);

                    if (this.checkSelectedAudience() && this.checkScheduleDatesCompatibility(
                        this.recurringDrips.schedule["date_start"],
                        this.recurringDrips.schedule["date_end"]
                    )) {
                        if (
                            !this.recurringDrips.schedule.days_of_week.length
                        ) {
                            this.recurringDrips.schedule.days_of_week = "Monday Tuesday Wednesday Thursday Friday Saturday Sunday";
                        }

                        if (
                            typeof this.recurringDrips.schedule.days_of_week === "string"
                        ) {
                            this.recurringDrips.schedule.days_of_week = this.recurringDrips.schedule.days_of_week.split(" ");
                        }

                        if (
                            this.recurringDrips.schedule.days_of_week.length
                        ) {
                            this.recurringDrips.schedule.days_of_week = this.recurringDrips.schedule.days_of_week.join(" ");
                        }

                        delete this.recurringDrips.schedules;

                        // External Settings
                        if (this.selectedExternal && this.shwExternalSettings) {
                            this.recurringDrips.external = this.selectedExternal;
                            this.recurringDrips.schedule.type = "external-recurring";
                        }

                        if (!this.shwExternalSettings && undefined !== this.recurringDrips.external && this.selectedNotifType !== "tail-recurring") {
                            this.recurringDrips.external = null;
                            this.recurringDrips.schedule.type = "recurring";
                        }

                        if (this.selectedNotifType === "tail-recurring") {
                            delete this.recurringDrips.audiences;
                        }

                        this.recurringDrips.schedule.type = this.selectedNotifType;

                        await Drip.createOrUpdate("recurring", recurringDrips)
                            .then((response) => {
                                if (response.status === 200 || response.status === 201) {
                                    this.snackbar = true;
                                } else {
                                    this.error = true;
                                }
                            })
                            .catch((err) => {
                                this.error = true;

                                return false;
                            });
                    } else {
                        this.processLoading = false;
                        this.errorSnackbar = true;
                        this.fireError = true;
                        this.error = true;

                        if (
                            this.checkScheduleDatesCompatibility(
                                this.recurringDrips.schedule.date_start,
                                this.recurringDrips.schedule.date_end)
                        ) {
                            this.failure = true;
                        } else {
                            this.scheduleDatesCompatibility = false;

                            setTimeout(() => {
                                this.scheduleDatesCompatibility = true;
                            }, 2000);
                        }

                        return false;
                    }
                }

                if (this.$route.name !== "Drip Setup" && event.target.innerText) {
                    let recurringRouteName = this.selectedNotifType == "tail-recurring" ? "Recurring Tails" : "Recurring";
                    this.success = true;
                    setTimeout(() => {
                        event.target.innerText === "Save Draft"
                            ? this.$router.push({ name: "Drafts" })
                            : this.$router.push({ name: recurringRouteName });

                    }, 2500);
                } else if (this.$route.name === "Drip Setup" || this.$route.name === "Send" && !event.target.innerText) {
                    this.success = true;
                    await this.resetDripSetupData();
                }

            } else {
                this.processLoading = false;
                this.errorSnackbar = true;
                this.fireError = true;
                this.error = true;

                this.failure = true;
            }

            setTimeout(() => {
                this.processLoading = false;
            }, 1500);
        },
        // Send Push Preview
        pushPreview() {
            // Check Servive Worker Existence
            if ("serviceWorker" in navigator) {
                // Register SW File
                navigator.serviceWorker.register("/sw.js");
                // Buttons Visiblility
                let shwActionBtns = this.shwActionBtns;
                let shwBtn2 = this.shwBtn2;
                // Title
                let title = this.recurringDrips.title;
                // Message
                let message = this.recurringDrips.body;
                // Buttons Title
                let btn1 = this.button1.title;
                let btn2 = this.button2.title;
                // Buttons Url
                let urlBtn1 = this.recurringDrips.customization?.button1 !== undefined ? this.recurringDrips.customization.button1.url : this.recurringDrips.url;
                let urlBtn2 = this.recurringDrips.customization?.button2 !== undefined ? this.recurringDrips.customization.button2.url : this.recurringDrips.url;
                // Actions
                let actions = [];
                // Data For Actions
                let data = {};
                // Images
                let icon = "";
                let image = "";

                if (document.querySelectorAll(".prev-icon-img")[0]) {
                    icon = document.querySelectorAll(".prev-icon-img")[0].src || "";
                }

                if (document.querySelectorAll(".prev-lg-img")[0]) {
                    image = document.querySelectorAll(".prev-lg-img")[0].src || "";
                }

                // Add Buttons
                if (shwActionBtns) {
                    // Add First Button
                    data.urlBtn1 = urlBtn1;
                    actions.push({
                        title: btn1,
                        action: "FirstBtnRedirect",
                    });
                    if (shwBtn2) {
                        // Add Second Button
                        data.urlBtn2 = urlBtn2;
                        actions.push(actions);
                        actions[1].title = btn2;
                        actions[1].action = "SecondBtnRedirect";
                    }
                }
                // Send Push If It Is Granted
                Notification.requestPermission(function (result) {
                    if (result === "granted") {
                        navigator.serviceWorker.ready.then(function (registration) {
                            registration.showNotification(title, {
                                icon: icon,
                                image: image,
                                body: message,
                                data: data,
                                actions: actions,
                            });
                        });
                    }
                });
            }
        },
        // Add Preview Large Image
        lgImgForPush() {
            // Large Picture
            var lgImg = document.querySelectorAll(".prev-lg-img");
            var lgImgFile = document.querySelectorAll("input[type=file]")[1].files[0];

            // Initialize Reader
            var reader = new FileReader();
            // Set Image Links To Selectors Attribute
            reader.onloadend = function () {
                // Large Image
                for (let el of lgImg) {
                    el.src = reader.result;
                }
            };
            // Read Content As File (Large Image)
            if (lgImgFile) {
                reader.readAsDataURL(lgImgFile);
            } else {
                lgImg.src = "";
            }
        },
        // Add Preview Icon Image
        iconImgForPush() {
            // Icon
            var iconImg = document.querySelectorAll(".prev-icon-img");
            var iconImgFile =
                document.querySelectorAll("input[type=file]")[0].files[0];
            // Initialize Reared
            var reader = new FileReader();

            // Set Image Links To Selectors Attribute
            reader.onloadend = function () {
                // Icon Image
                for (let el of iconImg) {
                    el.src = reader.result;
                    el.classList.add("animate__slideInLeft");
                    setTimeout(() => {
                        el.classList.remove("animate__slideInLeft");
                    }, 700);
                }
            };

            // Read Content As File (Icon)
            if (iconImgFile) {
                reader.readAsDataURL(iconImgFile);
            } else {
                iconImg.src = "";
            }

            this.shwIcons = "block";
        },
        checkField(field) {
            if (field === undefined) {
                return this.recurringDrips["schedule"];
            } else if (field !== undefined) {
                return this.recurringDrips["schedules"][0]
                    ? this.recurringDrips["schedules"][0]
                    : this.recurringDrips["schedules"][0];
            }
        },
        resetDripSetupData() {
            this.recurringDrips.title = "";
            this.recurringDrips.body = "";
            this.recurringDrips.url = "";
            this.recurringDrips.schedules = new Array(this.recurringDrips.schedule);
            this.ttl = "";

            this.button1.title = "";
            this.button2.title = "";


            this.selectedTags = [];
            this.selectedDomains = this.$route.name === "Send" ? new Array(this.$route.params.id) : [];

            this.shwLargeImg = false;
            this.shwAudience = false;
            this.shwActionBtns = false;
            this.shwBtn2 = false;

            this.selectedAudience = "";
            this.selectedDomainForGettingAudience = "";

            this.recurring[0].schedule.time = "";
            this.recurring[0].schedule.timezone = "";
            this.recurring[0].schedule.date_end = "";
            this.recurring[0].schedule.date_start = "";


            document.querySelector("#lgImage").checked = false;
            document.querySelector("#actionBtns").checked = false;

            document.querySelector(".v-file-input__text").innerText = "";
            document.querySelector(".prev-icon-img").style.backgroundImage = "";
        }
    },
    watch: {
        "$route.name": {
            async handler(value) {
                this.resetRecurringDrips();
            },
            deep: true,
            immediate: true,
        },
        url() {
            if (this.url) {
                this.loading = false;
            }
        },
        selectedNotifType(value) {
            switch (value) {
                case "oneTime":
                    this.shwOneTime = true;
                    this.shwRecurring = false;
                    this.shwMultipleTimes = false;
                    break;
                case "multipleTimes":
                    this.shwOneTime = false;
                    this.shwRecurring = false;
                    this.shwMultipleTimes = true;
                    break;
                case "recurring":
                    this.shwOneTime = false;
                    this.shwRecurring = true;
                    this.shwMultipleTimes = false;
                    break;
                default:
                    this.shwOneTime = false;
                    this.shwRecurring = false;
                    this.shwMultipleTimes = false;
            }
        },
        selectedDomainForGettingAudience(domain) {
            if (domain) {
                this.getAllFilters(
                    `?where[domain_id]=${domain}&where[type]=audience&where[is_system]=0`
                ).catch((err) => {
                    console.error(err);
                    this.$store.state.audience.audienceRecords = [];
                });
            }
        },
    },
};

export default recurring;